module.exports = __webpack_public_path__ + "static/media/triangle-1.09e0af1d.svg";